import { COMPLAINT_TYPE_LIST_PATH, COMPLAINT_TYPE_ADD_PATH, COMPLAINT_TYPE_EDIT_PATH, DEFAULT_DELETE_PATH } from '../../constants/paths';
import {ActionWindow} from '../../components/action_window/action_window';
import { complaintTypeAction } from './actions';
import { ComplaintTypeList, complaintTypeListLoader } from './complaint_type_list';
import { ComplaintType, complaintTypeAddLoader, complaintTypeEditLoader} from './complaint_type';
import { AuthProvider } from '../../auth_provider';

const complaintTypeRoutes = [
  {
    path: COMPLAINT_TYPE_LIST_PATH.slice(1),
    element: <ComplaintTypeList />,
    loader: complaintTypeListLoader,
    shouldRevalidate: ({ nextUrl, actionResult, formMethod }) => { 
        return AuthProvider.is_authenticated && nextUrl.pathname === COMPLAINT_TYPE_LIST_PATH && formMethod && (!actionResult || !actionResult.message);
    },
    children: [
      {
        path: `${DEFAULT_DELETE_PATH.slice(1)}:complaint_type_id`,
        element: <ActionWindow
            title="Deletar queixa"
            titleOnLoading="Deletando queixa"
            titleOnFail="Falha ao deletar queixa"
            description="Todos os dados relacionados à queixa serão removidos"
            confirmText="Deletar queixa"
            onCancelPath={COMPLAINT_TYPE_LIST_PATH}
            onFailPath={COMPLAINT_TYPE_LIST_PATH}
            onSuccessPath={COMPLAINT_TYPE_LIST_PATH}
            submitMethod="DELETE"
        />,
        action: complaintTypeAction
      }
    ]
  },
  {
      path: COMPLAINT_TYPE_ADD_PATH.slice(1),
      element: <ComplaintType key="complaint_type:add" isEdit={false} />,
      loader: complaintTypeAddLoader,
      shouldRevalidate: ({ formMethod }) => AuthProvider.is_authenticated && !formMethod,
      action: complaintTypeAction
  },
  {
      path: `${COMPLAINT_TYPE_EDIT_PATH.slice(1)}:complaint_type_id`,
      element: <ComplaintType key="complaint_type:edit" isEdit={true} />,
      loader: complaintTypeEditLoader,
      shouldRevalidate: ({ formMethod }) => AuthProvider.is_authenticated && !formMethod,
      action: complaintTypeAction
  },
];

export default complaintTypeRoutes;